import { useQuery } from "@tanstack/react-query";

import {
  ContactConfig,
  fetchContactConfig,
} from "../services/callStartService/fetchContactConfig";

const DEFAULT_CONTACT_CONFIG: ContactConfig = {
  buttonLabel: "Fale com a Start",
  title: "Fale com a Start",
  description:
    "Dúvidas, sugestões ou qualquer coisa que precise do nosso time — é só escrever.",
  subjects: [],
};

// Usuário logado sempre usa a config da tela "more".
export const useContactConfig = ({ enabled = true } = {}) => {
  const { data, isLoading } = useQuery({
    queryKey: ["contactConfig", "more"],
    queryFn: () => fetchContactConfig("more"),
    enabled,
    staleTime: 1000 * 60 * 30,
  });

  const config: ContactConfig = {
    buttonLabel: data?.buttonLabel || DEFAULT_CONTACT_CONFIG.buttonLabel,
    title: data?.title || DEFAULT_CONTACT_CONFIG.title,
    description: data?.description || DEFAULT_CONTACT_CONFIG.description,
    subjects: data?.subjects ?? DEFAULT_CONTACT_CONFIG.subjects,
  };

  return { config, isLoading };
};
